import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import Select from 'react-select';
import { BsCalendar2Range, BsFileBreak } from 'react-icons/bs';
import MySelect from '../../components/MySelect';
import PrintCheque from './PrintCheque';

const UpdateCheque = ({ selectedCheque, onClose }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken } = useStateContext();
    const [errors, setErrors] = useState(null);
    const [banques, setBanques] = useState([]);
    const [selectedBanque, setSelectedBanque] = useState(selectedCheque.banqueModel);
    const [inputValueBanque, setValueBanque] = useState('');

    const [showPrint, setShowPrint] = useState(false);

    const [selcetedCheque, setSelectedCheque] = useState(null);

    const [cheque, setCheque] = useState({
        idCheque:selectedCheque.id,
        banque: selectedCheque.banqueModel.id,
        ordreDe: selectedCheque.nom,
        montant: selectedCheque.montant,
        lieu: selectedCheque.lieu,
        date: selectedCheque.dateChequeNf,
    });

    const handleInputChangeBanque = value => {
        setValueBanque(value);
    };

    // handle selection
    const handleChangeBanque = value => {
        setSelectedBanque(value);
        setCheque({ ...cheque, banque: value.id });
    }


    const navigate = useNavigate();

    const getBanques = () => {
        axiosClient.get('/banques')
            .then((data) => {
                setBanques(data.data.banques);
            }).catch(err => {
                navigate('/500');
            })
    }

    

    useEffect(() => {

        getBanques();

    }, []);
    const onSubmit = () => {
        setErrors(null);
        setLoading(true);
        axiosClient.post('/cheque/update', cheque)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }



    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col  max-h-screen overflow-y-auto bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto md:w-1/4 lg:w-1/4 xl:w-1/4 rounded-xl'>
                        <div className=''>
                            <Header icon={<BsFileBreak />} title="Ajouter un cheque" titleAr={"إضافة حصة"} />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }
                        <>
                            <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-2'>
                                <div className='flex-col w-full justify-evenly '>
                                    <div className='mr-2'>
                                        <Input label="Date" labelAr="" type="date" value={cheque.date} onChange={ev => setCheque({ ...cheque, date: ev.target.value })} required="required" />
                                    </div>
                                    <div className="flex-col w-full">
                                        <MySelect label="Banque" labelAr="القسم" placeholder="Banque" cacheOptions defaultOptions value={selectedBanque} getOptionLabel={e => e.code} getOptionValue={e => e.id} options={banques} onInputChange={handleInputChangeBanque} onChange={handleChangeBanque} />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Montant" labelAr="" type="text" value={cheque.montant} onChange={ev => setCheque({ ...cheque, montant: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Ordre de" labelAr="" type="text" value={cheque.ordreDe} onChange={ev => setCheque({ ...cheque, ordreDe: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Lieu" labelAr="" type="text" value={cheque.lieu} onChange={ev => setCheque({ ...cheque, lieu: ev.target.value })} required="required" />
                                    </div>
                                </div>
                            </div>
                        </>

                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                {loading ? <Loading /> :
                                    <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />
                                }
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    )
}

export default UpdateCheque